import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

export const fetchRoutePolylines = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/route/fetchPolylines', async (routeIds, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/route/fetchPolylines', {
      category: 'rpc',
      type: 'rpc/route/fetchPolylines',
      routeIds,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {fetchPolylinesRoutes}`,
      { tags: ['rpc', 'order'], info: routeIds },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `FetchPolylines routes failed`,
      error,
    })
  }
})
